export const ORG_CYCLES_LIST_PATH = "/org/review-cycles";

export type CycleDetailOrigin = "settings" | "home";

export type CycleManagementOrigin = "org";

export type CycleReturnOrigin = Exclude<CycleDetailOrigin, "settings"> | CycleManagementOrigin;

export type CycleBuilderOrigin = CycleDetailOrigin | CycleManagementOrigin;

const SEGMENT_BY_ORIGIN = {
    settings: "/review-cycles/:cycleId",
    home: "/home/review-cycles/:cycleId"
} as const satisfies Record<CycleDetailOrigin, string>;

export function cycleDetailAreaSegment(origin: CycleDetailOrigin): string {
    return SEGMENT_BY_ORIGIN[origin];
}

const ORIGIN_PATH = {
    home: "/",
    org: ORG_CYCLES_LIST_PATH
} as const satisfies Record<CycleReturnOrigin, string>;

export function cycleOriginPath(origin: CycleReturnOrigin): string {
    return ORIGIN_PATH[origin];
}

export function cycleReturnOrigin(origin: CycleBuilderOrigin): CycleReturnOrigin {
    return origin === "settings" ? "org" : origin;
}

export function buildCycleDetailPath(origin: CycleDetailOrigin, cycleId: string): string {
    return SEGMENT_BY_ORIGIN[origin].replace(":cycleId", cycleId);
}

const BUILDER_BASE_BY_ORIGIN = {
    ...SEGMENT_BY_ORIGIN,
    org: `${ORG_CYCLES_LIST_PATH}/:cycleId`
} as const satisfies Record<CycleBuilderOrigin, string>;

export function cycleBuilderAreaSegment(origin: CycleBuilderOrigin): string {
    return `${BUILDER_BASE_BY_ORIGIN[origin]}/edit`;
}

export function buildCycleBuilderPath(origin: CycleBuilderOrigin, cycleId: string): string {
    return cycleBuilderAreaSegment(origin).replace(":cycleId", cycleId);
}

export function cycleReviewAreaSegment(origin: CycleDetailOrigin): string {
    return `${SEGMENT_BY_ORIGIN[origin]}/reviews/:personId`;
}

export function cycleCreateAreaSegment(origin: CycleBuilderOrigin): string {
    return BUILDER_BASE_BY_ORIGIN[origin].replace(":cycleId", "new");
}
